<template>
  <AdministrationHeader>
    <!-- Un autre container dans l'adresse : tout est rechargé -->
    <AdministrationPanel :key="$route.params.id" :load="load" v-slot="{ data, refresh }">
      <h1><span>Administration / <router-link to="/administration/containers">Containers</router-link> / </span>{{ data.container.id }}</h1>
      <ContainerPlacement :container="data.container" full class="container-placement" />
      <ContainerDetail :data="data" :callback="refresh" />
    </AdministrationPanel>
  </AdministrationHeader>
</template>

<script>
import AdministrationHeader from "@/administration/components/AdministrationHeader.vue";
import AdministrationPanel from "@/administration/components/AdministrationPanel.vue";
import ContainerDetail from "@/administration/components/ContainerDetail.vue";
import ContainerPlacement from "@/administration/components/ContainerPlacement.vue";
import {AdministrationController} from "@/administration/controllers/AdministrationController";

export default {
  name: 'AdministrationContainerView',
  components: {AdministrationHeader, AdministrationPanel, ContainerDetail, ContainerPlacement},
  methods: {
    load() {
      return AdministrationController.getContainer(this.$route.params.id);
    },
  },
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.container-placement
  margin-bottom 16px

h1
  color THEME_COLOR_PRIMARY
  span
    color THEME_COLOR_PRIMARY_FADDED

  a
    color inherit
    text-decoration none

    &:hover
      text-decoration underline
</style>
